//-----------------------------------
// create new characteristic entries
//-----------------------------------
export default function createNewCharacteristicEntries(race_chars) {
  console.log('------------------------------------')
  console.log('IN createNewCharacteristicEntries')
  /*
    used when creating a new character to set up - mainly for adjs arrays
  */
  let char_entries = []
  //---------------------------
  // loop race characteristics
  //---------------------------
  race_chars.forEach((rc) => {
    //----------------
    // set char entry
    //----------------
    const char_entry = {
      id: null, // empty as no character-characteristic yet
      character_name: '', // empty as no character yet
      name: rc.name,
      rolled: rc.value,
      cur: rc.value,
      improvs: 0,
      incr_percent: 0,
      integs_tot: 0,
      adjs_tot: 0,
      characteristic_adjs: [],
      integrated_rune_characteristic_adjs: [],
    }
    //------------------
    // store char entry
    //------------------
    char_entries.push(char_entry)
  })
  //---------------------
  // return char entries
  //---------------------
  return char_entries
}
